export const SUBMISSION_KINDS = {
  pptx: {
    badge: "PPTX",
    noun: "deck",
    label: "Google Slides link",
    placeholder: "https://docs.google.com/presentation/d/…",
    help: "Judges open this directly, so sharing must be “Anyone with the link · Viewer”.",
  },
  github: {
    badge: "GITHUB",
    noun: "repository",
    label: "GitHub repository",
    placeholder: "https://github.com/your-team/project",
    help: "Public, with a README that says how to run it. Judges clone this.",
  },
};

export const NOTHING_TO_SUBMIT_NOTES = {
  DEFAULT: "Nothing to submit right now.",
  NO_TEAM: "Nothing to submit yet. Get yourself a team first.",
  ELIMINATED: "Nothing to submit.",
};
